import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

// constants
import { ReactIcons, MuiIcons } from "../../icons";
import { USER_KEY } from "../../const";
import "./setting.css";

function Setting() {
  const history = useHistory();
  const { t } = useTranslation();
  const user_data = JSON.parse(localStorage.getItem(USER_KEY));
  const [role, setRole] = useState();

  useEffect(() => {
    if (user_data) {
      setRole(user_data?.data?.role);
    }
  }, [user_data]);

  const itemsSettingAdmin = [
    {
      title: t("setting_profile"),
      icon: <MuiIcons.AccountCircleIcon sx={{ fontSize: 34 }} />,
      path: "/settings/profile",
      document: t("setting_profile_doc"),
      isPermission: "SETTING_PROFILE",
    },
    {
      title: t("setting_product_type"),
      icon: <MuiIcons.BorderAllOutlinedIcon sx={{ fontSize: 34 }} />,
      path: "/settings/producttype/limit/50/page/1",
      document: t("setting_product_type_doc"),
      isPermission: "SETTING_PRODUCT_TYPE",
    },
    {
      title: t("setting_brand"),
      icon: <MuiIcons.AnnouncementOutlinedIcon sx={{ fontSize: 34 }} />,
      path: "/settings/brand/limit/50/page/1",
      document: t("setting_brand_doc"),
      isPermission: "SETTING_BRAND",
    },
    // {
    //   title: "ຊັບເເບນ",
    //   icon: <MuiIcons.AnnouncementOutlinedIcon sx={{ fontSize: 34 }} />,
    //   path: "/settings/subbrand/limit/50/page/1",
    //   document: "ສຳຫລັບການຕັ້ງຄ່າຊັບແບຣນ"
    // },
    {
      title: t("setting_option"),
      icon: <MuiIcons.SwapVertIcon sx={{ fontSize: 34 }} />,
      path: "/settings/option",
      document: t("setting_option_doc"),
      isPermission: "SETTING_OPTION",
    },
    {
      title: t("setting_production_tracking"),
      icon: <ReactIcons.MdOutlineProductionQuantityLimits style={{ fontSize: 34 }} />,
      path: "/settings/production_tracking",
      document: t("setting_production_tracking_doc"),
      show: user_data?.data?.shop?.id === "69a7e3eb629c3100136283dd",
      isPermission: "SETTING_MANAGEMENT",
    },
    {
      title: "ຈັດການ Size / ຈັດການຜ້າ",
      icon: <ReactIcons.FaUnity style={{ fontSize: 34 }} />,
      path: "/settings/shop-size",
      document: "ຈັດການ Size ແລະ ປະເພດຜ້າ",
      show: user_data?.data?.shop?.id === "69a7e3eb629c3100136283dd",
      isPermission: "SETTING_MANAGEMENT",
    },
    {
      title: t("setting_exchange_rate"),
      icon: <MuiIcons.PriceChangeOutlinedIcon sx={{ fontSize: 34 }} />,
      path: "/exchangerate",
      document: t("setting_exchange_rate_doc"),
      isPermission: "SETTING_EXCHANGE_RATE",
    },
    {
      title: t("setting_printer"),
      icon: <MuiIcons.PrintIcon sx={{ fontSize: 34 }} />,
      path: "/printer/limit/50/page/1",
      document: t("setting_printer_doc"),
      isPermission: "SETTING_PRINTER",
    },
    {
      title: t("setting_barcode"),
      icon: <ReactIcons.AiOutlineBarcode size={34} />,
      path: "/settings/barcode/limit/50/page/1",
      document: t("setting_barcode_doc"),
      isPermission: "SETTING_BARCODE",
    },
    {
      title: t("setting_customer"),
      icon: <MuiIcons.GroupAddIcon sx={{ fontSize: 34 }} />,
      path: "/settings/customer/limit/50/page/1",
      document: t("setting_customer_doc"),
      isPermission: "SETTING_CUSTOMER",
    },
    {
      title: t("setting_bank"),
      icon: <MuiIcons.AccountBalanceWalletIcon sx={{ fontSize: 34 }} />,
      path: "/settings/bank",
      document: t("setting_bank_doc"),
      isPermission: "SETTING_BANK",
    },
    {
      title: t("setting_staff"),
      icon: <ReactIcons.FaUsers style={{ fontSize: 34 }} />,
      path: "/settings/User",
      document: t("setting_staff_doc"),
      isPermission: "STAFF_MANAGEMENT",
    },
    {
      title: user_data?.data?.shop?.id === "69a7e3eb629c3100136283dd" ? "ຈັດການໂປຣໂມຊັ່ນ ແລະ ຂອງແຖມ" : t("setting_reward"),
      icon: <ReactIcons.BsGiftFill style={{ fontSize: 34 }} />,
      path: "/settings/reward",
      document: t("setting_reward_doc"),
      isPermission: "STAFF_MANAGEMENT",
    },

    {
      title: t("setting_bill"),
      icon: <ReactIcons.TbFileInvoice style={{ fontSize: 34 }} />,
      path: "/settings/bill_setting",
      document: t("setting_bill_doc"),
      isPermission: "SETTING_BILL",
    },
    {
      title: t("setting_role"),
      icon: <ReactIcons.MdPrivacyTip style={{ fontSize: 34 }} />,
      path: "/settings/role",
      newFeature: false,
      document: t("setting_role_doc"),
      isPermission: "ROLE_MANAGEMENT",
    },
    {
      title: t("setting_language"),
      icon: <ReactIcons.IoLanguage style={{ fontSize: 34 }} />,
      path: "/settings/language",
      newFeature: false,
      document: t("setting_language_doc"),
      isPermission: "SETTING_LANGUAGE",
    },
    {
      title: t("setting_damaged_inventory"),
      icon: <ReactIcons.RiFileDamageFill style={{ fontSize: 34 }} />,
      path: "/settings/damaged_inventory",
      newFeature: false,
      document: t("setting_damaged_inventory_doc"),
      isPermission: "SETTING_DAMAGED_INVENTORY",
    },
    {
      title: t("setting_shop"),
      icon: <MuiIcons.AddBusinessIcon sx={{ fontSize: 34 }} />,
      path: {
        pathname: `/settings/shop/${user_data?.data?.shop?.id}`,
        state: { shop: user_data?.data?.shop }
      },
      newFeature: true,
      document: t("setting_shop_doc"),
      isPermission: "SETTING_SHOP",
    }
  ];

  // check role and permission
  const isAdmin = role === "ADMIN";

  return (
    <div style={{ height: 'auto', minHeight: '100vh', padding: 20 }}>
      <h5>{t("setting_page_title")}</h5>
      <p>{t("setting_page_description")}</p>
      <div className="card-setting">
        {itemsSettingAdmin
          .filter(item => (item.show === undefined || item.show === true))
          .map((item, index) => (
            <div className="card-item" key={index} onClick={() => history.push(item?.path)}>
              {item?.newFeature &&
                <span className="newFeature-text">New</span>
              }
              <div>{item?.icon}</div>
              <h4>{item?.title}</h4>
              <p style={{fontWeight: "normal", marginTop: -5}}>{item?.document}</p>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Setting;
